export var positions = [[-1, -1, 0], [1, -1, 0], [1, 1, 0], [-1, 1, 0]];
export var uv = [[0, 0], [1, 0], [1, 1], [0, 1]];
export var elements = [0, 1, 2, 0, 2, 3];